export default "### GeoWeb - A system for digital property rights\n";